"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasTransforms = void 0;
/**
 * @public
 * {@inheritDoc ICanvasTransforms}
 */
class CanvasTransforms {
    constructor(clipToPixel, clipToCss, pixelToClip, cssToClip) {
        this.clipToPixel = clipToPixel;
        this.clipToCss = clipToCss;
        this.pixelToClip = pixelToClip;
        this.cssToClip = cssToClip;
    }
}
exports.CanvasTransforms = CanvasTransforms;
//# sourceMappingURL=canvas-transforms.js.map